export default "__VITE_ASSET__DaoannDF__"